module.exports = __webpack_public_path__ + "images/stick-out-tongue.png";